//#region src/domain/errors/api-error.ts
var ApiError = class extends Error {
	apiError;
	constructor(message, apiError) {
		super(message || "An unexpected error occurred.");
		this.apiError = apiError;
	}
};
//#endregion
export { ApiError };

//# sourceMappingURL=api-error.js.map